var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded === true
    ? _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-row time-counter justify-content-between",
              class: { expired: _vm.expired },
              attrs: { id: _vm.id }
            },
            [
              _vm.availableSection.days === true
                ? _c(
                    "div",
                    { staticClass: "d-flex flex-column align-items-center" },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.days))
                      ]),
                      _vm._v(" "),
                      _vm.displayHint === true
                        ? _c("span", { staticClass: "time-counter-hint" }, [
                            _vm._v(_vm._s(_vm.timeNames.days))
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.availableSection.days === true
                ? _c("span", { staticClass: "counter-colon" }, [_vm._v(":")])
                : _vm._e(),
              _vm._v(" "),
              _vm.availableSection.hours === true
                ? _c(
                    "div",
                    { staticClass: "d-flex flex-column align-items-center" },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.hours))
                      ]),
                      _vm._v(" "),
                      _vm.displayHint === true
                        ? _c("span", { staticClass: "time-counter-hint" }, [
                            _vm._v(_vm._s(_vm.timeNames.hours))
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.availableSection.hours === true
                ? _c("span", { staticClass: "counter-colon" }, [_vm._v(":")])
                : _vm._e(),
              _vm._v(" "),
              _vm.availableSection.minutes === true
                ? _c(
                    "div",
                    { staticClass: "d-flex flex-column align-items-center" },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.minutes))
                      ]),
                      _vm._v(" "),
                      _vm.displayHint === true
                        ? _c("span", { staticClass: "time-counter-hint" }, [
                            _vm._v(_vm._s(_vm.timeNames.minutes))
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.availableSection.minutes === true
                ? _c("span", { staticClass: "counter-colon" }, [_vm._v(":")])
                : _vm._e(),
              _vm._v(" "),
              _vm.availableSection.seconds === true
                ? _c(
                    "div",
                    { staticClass: "d-flex flex-column align-items-center" },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.seconds))
                      ]),
                      _vm._v(" "),
                      _vm.displayHint === true
                        ? _c("span", { staticClass: "time-counter-hint" }, [
                            _vm._v(_vm._s(_vm.timeNames.seconds))
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.expired
            ? _c(
                "b-tooltip",
                { attrs: { target: String(_vm.id), triggers: "hover" } },
                [_vm._v("Время вышло")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.expired
            ? _c(
                "b-tooltip",
                { attrs: { target: String(_vm.id), triggers: "hover" } },
                [_vm._v("Время, за которое заказ должен завершиться")]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b458e8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b458e8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TimeCounter.vue
// module id = null
// module chunks = 